import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=12962e7d&scoped=true"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"
import style0 from "./TestDetail.vue?vue&type=style&index=0&id=12962e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12962e7d",
  null
  
)

export default component.exports